<app-dialog>
  <app-dialog-title>{{
    (!data
      ? 'ACCOUNT.GROUPS.DIALOG.ADD_CATEGORY_TITLE'
      : 'ACCOUNT.GROUPS.DIALOG.EDIT_CATEGORY_TITLE'
    ) | translate
  }}</app-dialog-title>
  <app-dialog-content>
    <p class="NewCategory__explainer">
      {{
        'ACCOUNT.GROUPS.DIALOG.CATEGORY_EXPLAINER'
          | translate: { childrenNamePlural: accountChildrenNamePlural }
      }}
    </p>
    <form [formGroup]="categoryForm">
      <mat-form-field class="w-100">
        <mat-label>{{ 'SHARED.SYSTEM.NAME' | translate }}</mat-label>
        <input
          matInput
          autocomplete="off"
          list="autocompleteOff"
          required
          name="name"
          #nameInput
          formControlName="name"
          [placeholder]="'ACCOUNT.GROUPS.DIALOG.CATEGORY_NAME_PLACEHOLDER' | translate"
          data-testid="input-category-name" />
        <mat-error appErrors="name" [errors]="errors" />
      </mat-form-field>
    </form>
  </app-dialog-content>
  <app-dialog-actions>
    <button matButton="outlined" type="button" class="me-1" matDialogClose data-testid="btn-cancel">
      {{ 'ACCOUNT.GROUPS.BUTTONS.CANCEL' | translate }}
    </button>
    <button matButton="filled" type="button" (click)="save()" data-testid="btn-save-category">
      {{
        (!data ? 'ACCOUNT.GROUPS.DIALOG.CREATE_CATEGORY_BUTTON' : 'SHARED.SYSTEM.SAVE') | translate
      }}
    </button>
  </app-dialog-actions>
</app-dialog>
